import { render } from "./RuiSuccess.vue?vue&type=template&id=3a6a42af"
const script = {}
script.render = render

export default script